import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { IrrigationType, IrrigationOut, Irrigation, CompleteIrrigation, Activity } from "../models/Irrigation";
import { toHA } from '../models/Utils';

export default class IrrigationApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath
    }

    public async getIrrigationTypes(paging: PagingParams, filter: string | null): Promise<PagedResults<IrrigationType>> {
        const res = await this.http.get(`${this.rootPath}/v1/plots/dictionary_irrigation_type`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filter ? `^ds_irrigation_type like ${filter.toUpperCase()}` : undefined
            }
        })

        return res.data;
    }

    public async editIrrigation(plot_id: number, action_id: number, editedIrrigation: IrrigationOut): Promise<Irrigation> {
        const res = await this.http.put(`${this.rootPath}/v1/plots/plots/${plot_id}/activities/${action_id}/irrigation`, editedIrrigation);
        toHA(res.data, ["area_covered"]);
        return res.data;
    }

    public async editProtocolIrrigation(pkCuaa: number, protocol_id: number, action_id: number, editedIrrigation: Partial<IrrigationOut>): Promise<Irrigation> {
        const res = await this.http.put(`${this.rootPath}/v1/protocols/subjects/${pkCuaa}/dictionary_protocols/${protocol_id}/activities/${action_id}/irrigation`, editedIrrigation);
        return res.data;
    }

    public async addActionIrrigation(plot_id: number, execution_id: number, newirrigation: IrrigationOut): Promise<Irrigation> {
        const res = await this.http.post(`${this.rootPath}/v1/plots/plots/${plot_id}/actions/${execution_id}/irrigation`, newirrigation);
        return res.data;
    }

    public async deleteActionIrrigation(pk_cuaa: number, campaign: number, execution_id: number, action_id: number): Promise<Irrigation> {
        const res = await this.http.delete(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/actions/${execution_id}/irrigation/${action_id}`);
        return res.data;
    }

    public async getIrrigations(pk_cuaa: number, campaign: number, plot_id: number): Promise<CompleteIrrigation[]> {

        const res = await this.http.get(
            `/sitiagri-rest-api/api_basic/v1/plots/dashboard/subjects/${pk_cuaa}/campaigns/${campaign}/irrigations`,
            {
                params: {
                    plot_id
                }
            }
        );

        return res.data

    }

    public async getNewIrrigationInfo(pk_cuaa: number): Promise<Activity>
    {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/dashboard/subjects/${pk_cuaa}/irrigation_activity`)

        return res.data
    }

    public async deletePlannedIrrigation(plot_id: number, activity_id: number): Promise<number>
    {
        const res = await this.http.delete(`/sitiagri-rest-api/api_basic/v1/plots/plots/${plot_id}/activities/${activity_id}`)

        return res.status
    }
}
